import { z } from 'zod'

export const E164PhoneNumberSchema = z.string().regex(/^\+1\d{10}$/)

export function formatE164PhoneNumber(e164PhoneNumber: string) {
  return E164PhoneNumberSchema.parse(e164PhoneNumber)
    .substring(2)
    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
}

export function tryFormatE164PhoneNumber(e164PhoneNumber: string) {
  const parsedPhoneNumber = E164PhoneNumberSchema.safeParse(e164PhoneNumber)
  if (!parsedPhoneNumber.success) {
    return null
  }

  return formatE164PhoneNumber(parsedPhoneNumber.data)
}

export function toE164PhoneNumber(phoneNumber: string) {
  return `+1${phoneNumber}`
}
